import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pui-page',
  templateUrl: 'page.component.html'
})
export class PuiPageComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
